<template>
    <div class="matrix-filter" :class="{ 'filter-centered': !hasPatients }">
        <div class="filter-search">
            <form action="" @submit.prevent="search" autocomplete="off">
                <div class="input-wrapper" :class="{ 'has-error': showNothingFoundAlert && !hasPatients }">
                    <button type="submit" @click.prevent="search">
                        <svg-icon icon="search" />
                    </button>
                    <button class="filter-remove" type="button" @click.prevent="remove">
                        <span class="material-icons-round">close</span>
                    </button>

                    <label for="searchValue" :class="['is-float-label', { 'float-label-active': isFloatLabelActive }]">Name / E-mail / Patient ID / User ID</label>

                    <input id="searchValue" type="text" placeholder="Name / E-mail / Patient ID / User ID" v-model="searchValue" />

                    <form-input-error v-if="showNothingFoundAlert && !hasPatients" :error="__('Patient not found.')"></form-input-error>
                </div>

                <template v-if="!hasPatients">
                    <VButton :label="__('Search')" type="submit" :disabled="searchValue === ''" />
                </template>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    props: ['anonymized'],
    data() {
        return {
            showNothingFoundAlert: false,
            hasPatients: false,
            patients: [],
            searchValue: '',
            isFloatLabelActive: false
        }
    },
    watch: {
        anonymized: function(newVal) {
            if (newVal === true) {
                this.search()
            }
        },
        searchValue(value) {
            if (value === '') {
                this.remove()
            }

            if(value.length > 0) {
                this.isFloatLabelActive = true
            } else {
                this.isFloatLabelActive = false
            }
        }
    },
    created() {
        if (window.localStorage.searchEmail) {
            this.hasPatients = true
            this.searchValue = window.localStorage.searchEmail
            this.search()
            window.localStorage.removeItem('searchEmail')
        }
    },
    mounted() {
        Vuemit.listen('Search--patient-showed', this.saveSearchStatus)
    },
    beforeDestroy() {
        Vuemit.remove('Search--patient-showed', this.saveSearchStatus)
    },
    methods: {
        search() {
            axios.get(`/user/anonymization?search=${encodeURIComponent(this.searchValue)}`).then((r) => {
                if (r.data.users.length === 0 && r.data.pending_patients.length === 0) {
                    this.showNothingFoundAlert = true
                    this.hasPatients = false
                } else {
                    this.showNothingFoundAlert = false
                    this.hasPatients = true
                }

                this.$emit('search', r.data)
                Vuemit.fire('Button--sending-failed', true)
            })
        },
        remove() {
            this.searchValue = ''
            window.localStorage.removeItem('searchEmail')
            this.hasPatients = false
            this.$emit('search', this.patients)
        },
        saveSearchStatus() {
            window.localStorage.searchEmail = this.searchValue
        }
    }
}
</script>
